module.exports = __webpack_public_path__ + "static/better-footer-240936ec8acfc1a94d540763af635e73.svg";